module.exports = __webpack_public_path__ + "img/人事管理.484f33c0.png";